import type { IconProps } from './types';
import './icons.css';

export default function Search({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-search ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="m13.334 13.333 3.333 3.334-3.334-3.334ZM15 9.167a5.833 5.833 0 1 1-11.666 0 5.833 5.833 0 0 1 11.666 0Z"
      />
    </svg>
  );
}
